import { get, post, postJson, put, deleteApi } from './axios2'

/**创建活动 */
export const saveSinglesActivity = p => postJson(`/show-product/save`, p);

/**获取活动详情 */
export const getActivityDetail = (id) => get(`/show-product/detail/${id}`);

/**
 * [用户资料列表]
 * @param {*} p 
 * @returns 
 */
export const getUserProfileList = (p) => get(`/show-product/userProfile/list`,p);
/**
 * [新增用户资料列表]
 */
export const addUserProfile = (p) => postJson(`/show-product/userProfile`,p);

/**
 * [用户资料汇总]
 * @param {*} p 
 * @returns 
 */
export const getUserProfileStatic = (p) => get(`/show-product/userProfile/summary`,p);

/**
 * [审核/批量审核]
 */
export const processUserProfile = (p) => postJson(`/show-product/userProfile/process`,p);

/**
 * [剩余可通过审批人数]
 */
export const getCanProcessNum = (p) => get(`/show-product/userProfile/canProcessNum`,p);

/**
 * [用户资料列表导出]
 */
export const exportUserProfile = (p) => postJson(`/show-product/userProfile/export`,p);

/**
 * [用户资料列表导出-平台版(云舟使用)]
 * @param {*} p 
 * @returns 
 */
export const exportPlatformUserProfile = (p) => postJson(`/show-product/userProfile/platform-export`,p);


/**中奖记录导出 */
export const exportPrizeDetail = p => postJson(`/PointActivityEffectDetails/exportPointActivityPrizeDetail`, p)

/**会员升级礼参与记录导出 */
export const exportMemberDetail = p => postJson(`/memberLevelGift/exportGiftRecord`, p)

/**情书贺卡参与记录导出 */
export const exportBilletDetail = p => postJson(`/LoveLetterGreetingCardController/participants/platform-export`, p)

/**情书贺卡获取记录导出 */
export const exportBilletReceive = p => postJson(`/LoveLetterGreetingCardController/acquisition/platform-export`, p)



